import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const useBuyNow = (userId, asset, handleClose) => {
  const [selectedWallet, setSelectedWallet] = useState('');
  const [buying, setBuying] = useState(false);
  const [purchaseError, setPurchaseError] = useState(null);
  const [purchaseSuccess, setPurchaseSuccess] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleBuyNow = async () => {
    setBuying(true);
    setPurchaseError(null);
    setPurchaseSuccess(false);

    try {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_API_AUDIENCE,
        },
      });

      const transactionData = {
        assetId: asset.id,
        seller: asset.ownedByUserId,
        sellerWalletId: asset.recipientWalletAddress,
        buyer: userId,
        buyerWalletId: selectedWallet,
        salePrice: asset.salePrice,
        createdOn: new Date().toISOString(),
      };

      const response = await fetch(`${apiUrl}/api/transactions`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(transactionData),
      });

      if (!response.ok) {
        throw new Error(`Purchase failed (${response.status})`);
      }

      setPurchaseSuccess(true);
      if (typeof handleClose === 'function') {
        handleClose();
      }
    } catch (error) {
      console.error('Error submitting purchase:', error);
      setPurchaseError('Could not complete purchase. Please retry.');
    } finally {
      setBuying(false);
    }
  };

  return { selectedWallet, setSelectedWallet, handleBuyNow, buying, purchaseError, purchaseSuccess };
};

export default useBuyNow;
